import Vuex from 'vuex';
import auth from '../auth';
import tv from './modules/tv';
import suite from './modules/suite';
import suiteGroup from './modules/suite-group';
import tablet from './modules/tablet';
import remote from './modules/remote';
import group from './modules/group';
import section from './modules/section';
import user from './modules/user';
import event from './modules/event';

export default () => new Vuex.Store({
  state: {
    err: '',
    baseUrl: process.env.NODE_ENV === 'development' ? 'http://localhost:3000/' : '/',
    isLoggedIn: auth.isLoggedIn,
    logout: auth.logout,
    role: null,
  },

  mutations: {
    setRole(state, role) {
      state.role = role;
    },
  },
  actions: {
    setRole({ commit }, sections) {
      commit('setRole', sections);
    },
  },
  getters: {
    role(state) { return state.role; },
  },
  modules: {
    tv,
    suite,
    suiteGroup,
    tablet,
    remote,
    group,
    section,
    user,
    event,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js